import styled from 'styled-components';

export const FuturaTarjetaWrapper = styled.div`

._3sTov _35oaN{

    margin: 10px;
}

.Card-Class{
    background: white;
    margin-bottom: 35px;
}
.contedor-comprobante {
    margin-bottom: 35px;
}

.futura-tarjeta-header-black {
    background: rgb(2,0,36);
    background: linear-gradient(
    180deg, rgba(2,0,36,1) 0%, rgba(0,0,0,1) 55%, rgba(212,205,205,1) 100%);
    border-radius: 5px;
    margin: 0px 0 32px 0;
    height: 250px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-content: center;
    padding: 60px 60px 34px 60px;
    align-items: center;
    
}

.img.tarjetainternacional.mobile{
    display:none;
}

.t-internacional img {
    position: relative;
    left: 30px;
}

.p-internacional {
    color: white;
    font-weight: bold;
    
}

.p-internacional-dos {
    // position: relative;
    // top: -109px;
    // left: 31.5rem;
    color: white;
    
}

.t-internacional-texto {
    padding-bottom: 32px;
}

.t-internacional .titulo {
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
}

.t-internacional .subtitulo {
    font-size: 0.9rem;
    color: #FFFFFF;
}


p.p-internacional-dos {
    position: relative;
    top: 20px;
    font-size: 0.8rem;
    font-weight: 500;
    max-width: 210px;
}

.t-internacional .texto {
    position: relative;
    left: 46px;
    bottom: 76px;
}
.card {
    margin-top: 16px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 30px;
}
.div-mensaje{

    margin-top: 20px;
}

.t-internacional .titulo {
    // margin-left: 64px;
    // margin-top: -210px;
    font-size: 1.5rem;
    line-height: 1.5;
    font-weight: bold;
    color: white;
}

.contenedor-blackcard {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    text-align: center;
}


.p-mensaje {
    font-size: 0.9rem;
    margin-bottom: 8px;
    font-weight: 600;
}

.info .p-coment {
    font-size: 0.8rem;
    line-height: 17px;
    color: #333333;
}

.plastic{

    display: flex;
    justify-content: center;
}

.req-div{

    margin-top: 19px;
}

.t-dorada img{
    width: 100%;
    height: auto;

}
.Titulo h1 {
    font-size: 1.5rem;
    margin: 20px 0px 20px 0px;
    }
    .mensaje {
        margin: 12px 0px 20px 0px;
    }

@media (min-width: 420px){
    img.tarjetainternacional.desktop{
        display:none;
    }
}

@media (max-width: 425px){
    
    .futura-tarjeta-header-black {
        margin: 0px -11px -48px -11px;
        height: auto;
    }
    img.tarjetainternacional.desktop{
        display:none;
    }
    
    .tarjetainternacional .mobile{
        display:block;
    }
    .futura-tarjeta-header-black{
        grid-template-columns: 1fr;
    }
    
    .futura-tarjeta-header-black .t-internacional:nth-child(2){
        text-align: center;   
    }
    .t-internacional img {
        position: relative;
        left: 0;
        width: 294px;
    }
    .p-internacional-dos {
        text-align: left;
        padding-left: 24px;
        top: 26px;
    }
    .futura-tarjeta-header-black {

        margin: 0px -10px -52px -10px;
        padding: 10px;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 46px;
        bottom: 76px;
    }

    .futura-tarjeta-header-black .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 40px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blackcard{
        grid-template-columns: 1fr;
    }
    .contenedor-blackcard {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
}


@media (max-width: 376px){ 

    .img.tarjetainternacional.desktop{
        display:none;
    }

    .tarjetainternacional .mobile{
        display:block;
    }

    .t-internacional img {
        position: inherit;
        left: 0;
        width: inherit;
    }
    .futura-tarjeta-header-black {
        margin: 0px -10px -52px -10px;
        padding: 10px;
    }

    p.p-internacional-dos {
        text-align: left;
        padding-left: 24px;
        top: 24px;
    }

    .futura-tarjeta-header-black .t-internacional:nth-child(2){
        text-align: center;   
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: 25px;
        bottom: 72px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 20px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blackcard{
        grid-template-columns: 1fr;
    }
    .contenedor-blackcard {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
}


@media (max-width: 321px){ 
    .img.tarjetainternacional.desktop{
        display:none;
    }
    .img.tarjetainternacional.mobile{
        display:block;
    }
    .t-internacional img {
        position: relative;
        left: 0;
        width: 294px;
    }
    .futura-tarjeta-header-black {

        margin: 0px -10px -52px -10px;
        padding: 10px;
    }

    .t-internacional .texto {
        width: 200px;
        position: relative;
        left: -5px;
        bottom: 74px;
        
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) {
        padding: 15px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .titulo{
        font-size: 1rem;
        margin-left: 0px;
    }
    .futura-tarjeta-header-black .t-internacional:nth-child(1) .subtitulo{
        font-size: 0.9rem;
        line-height: 19px;
        display: none;
    }
    .contenedor-blackcard{
        grid-template-columns: 1fr;
    }
    .contenedor-blackcard {
        gap: 20px;
    }
    .Card-Class h1 {
        font-size: 1.1rem !important;
    }
    .Titulo h1 {
        font-size: 1.125rem;
        margin: 20px 0px 20px 0px;
        }
        .mensaje {
            margin: 12px 0px 20px 0px;
        }
}

`;

export default FuturaTarjetaWrapper;